module.exports = function(bootstrap){
    bootstrap.directive('affirm', function () {

        return{
            restrict: 'A',
            replace: true,
            scope: {
                affirm: '=',
                question: '=',
                formData: '=',
                coremetrics: '=',
                isFacility: '='
            },
            template : '<div class="affirm">' +
                            '<div tabindex="0" data-ng-click="affirm = 1" data-ng-keypress="affirm = 1">' +
                                '<input id="directive!" type="radio" data-ng-attr-id="formData[question.number]" data-ng-model="formData[question.number]" data-ng-attr-name="{{ question.number }}" value="1" data-ng-checked="affirm == 1" data-ng-required="{{ question.required === \'Y\' }}">' +
                                '<label data-ng-click="fireCoremetrics(question.text, 1)" data-ng-class="{checked:affirm == 1}" data-ng-attr-for="{{ formData[affirm] }}"><div class="hm-icon icon-mark-as-helpful"></div><br>Yes</label>' +
                            '</div>' +
                            '<div tabindex="0" data-ng-click="affirm = 0" data-ng-keypress="affirm = 0">' +
                                '<input id="directive!" type="radio" data-ng-attr-id="formData[question.number]" data-ng-model="formData[question.number]" data-ng-attr-name="{{ question.number }}" value="0" data-ng-checked="affirm == 0" data-ng-required="{{ question.required === \'Y\' }}"/>' +
                                '<label data-ng-click="fireCoremetrics(question.text, 0)" data-ng-class="{checked:affirm == 0}" data-ng-attr-for="{{ formData[affirm] }}"><div class="hm-icon icon-mark-as-not-helpful"></div><br>No</label>'+
                            '</div>' +
                        '</div>',
            controller: ['$scope', 'coremetrics', function ($scope, coremetrics) {

                var type = $scope.isFacility ? 'PROVIDER' : 'FACILITIES';

                $scope.affirm = null;

                $scope.fireCoremetrics = function (name, value) {
                    if (name && value !== undefined) {
                        coremetrics.elementTag($scope.coremetrics.categoryId + ':REVIEW ' + type + ':' + name.toUpperCase() + ' ' + 'AFFIRM ' + value, $scope.coremetrics.categoryId);
                    }
                };
            }]
        };
    });
};